import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import React, { useState } from 'react';

function ImageCropper(props) {
  const { imageToCrop, onImageCropped } = props;

  const [crop, setCrop] = useState(undefined);
  const [aspect, setAspect] = useState(1 / 1);
  const [imageRef, setImageRef] = useState();

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 60,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  }

  function onImageLoad(e) {
    setImageRef(e.currentTarget);

    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
    }
  }

  const onCropComplete = (crop) => {
    makeClientCrop(crop);
  };

  async function makeClientCrop(crop) {
    if (imageRef && crop.width && crop.height) {
      const croppedImageUrl = getCroppedImg(imageRef, crop);
      onImageCropped(croppedImageUrl);
    }
  }

  function getCroppedImg(image, crop) {
    const canvas = document.createElement('canvas');
    const pixelRatio = window.devicePixelRatio;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    const base64Image = canvas.toDataURL('image/jpeg');
    return base64Image;
  }

  return (
    <div className='d-flex justify-content-center p-3'>
      {imageToCrop && (
        <ReactCrop
          crop={crop}
          onChange={(_, percentCrop) => setCrop(percentCrop)}
          onComplete={(c) => onCropComplete(c)}
          aspect={aspect}
          crossorigin='anonymous'
        >
          <img alt='Crop me' src={imageToCrop} onLoad={onImageLoad} />
        </ReactCrop>
      )}
    </div>
  );
}

export default ImageCropper;
